if (!customElements.get('pw-inline-product-video')) {
  customElements.define('pw-inline-product-video', class extends HTMLElement {
    connectedCallback() {
      this.prepare = () => {
        if (this.video) return;
        const template = this.querySelector('template');
        if (!template) return;
        template.replaceWith(template.content.cloneNode(true));
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.video.controls = false;
        this.video.muted = true;
        this.video.loop = true;
        this.video.setAttribute('playsinline', '');
        this.video.style.cssText += ';position:absolute;inset:0;opacity:1;filter:none;width:100%;height:100%;object-fit:cover';
        this.video.preload = 'auto';
        this.video.load();
      this.pauseButton = document.createElement('button');
      this.pauseButton.type = 'button';
      this.pauseButton.className = 'pw-video-toggle';
      this.pauseButton.innerHTML = '<span aria-hidden="true">Ⅱ</span>';
      this.pauseButton.setAttribute('aria-label', 'Pause video');
      const updateButton = () => {
        this.pauseButton.setAttribute('aria-label', this.video.paused ? 'Play video' : 'Pause video');
        this.pauseButton.firstElementChild.textContent = this.video.paused ? '▶' : 'Ⅱ';
      };
      this.pauseButton.addEventListener('click', () => {
        if (this.video.paused) { this.userPaused = false; this.video.play().catch(() => {}); }
        else { this.userPaused = true; this.video.pause(); }
      });
      this.video.addEventListener('playing', updateButton);
      this.video.addEventListener('pause', updateButton);
      this.append(this.pauseButton);

      };
      this.preloader = new IntersectionObserver(entries => {
        if (entries.some(e => e.isIntersecting) && this.offsetWidth) this.prepare();
      }, {rootMargin:'200px 0px'});
      this.observer = new IntersectionObserver(entries => {
        const visible = entries.some(e => e.isIntersecting && e.intersectionRatio >= 0.1) && this.offsetWidth;
        if (visible) { this.prepare(); if (!this.userPaused) this.video?.play().catch(() => {}); }
        else this.video?.pause();
      }, {threshold:[0,0.1]});
      this.preloader.observe(this);
      this.observer.observe(this);
    }
    disconnectedCallback() { this.preloader?.disconnect(); this.observer?.disconnect(); this.video?.pause(); }
  });
}
